/**
 * Business review summary widget:
 * shows live rating stats in the business site summary widget.
 */
(function () {
  "use strict";

  function getMdbRatingClass() {
    var m = window.mdb;
    if (!m) {
      return null;
    }
    if (typeof m.Rating === "function") {
      return m.Rating;
    }
    var d = m.default;
    if (d && typeof d.Rating === "function") {
      return d.Rating;
    }
    return null;
  }

  function setText(el, value) {
    if (el) {
      el.textContent = value;
    }
  }

  function updateReadonlyRating(list, value) {
    if (!list) {
      return;
    }
    list.setAttribute("data-mdb-value", String(value));

    var RatingClass = getMdbRatingClass();
    if (!RatingClass) {
      return;
    }

    try {
      var instance =
        typeof RatingClass.getInstance === "function" ? RatingClass.getInstance(list) : null;
      if (instance && typeof instance.dispose === "function") {
        instance.dispose();
      }
    } catch (err) {
      console.error("[business-sites] review rating dispose", err);
    }

    if (typeof window.businessSitesInitMdbComponents === "function") {
      window.businessSitesInitMdbComponents();
    }
  }

  function readInitialStats(widget) {
    if (!widget) {
      return null;
    }

    return {
      average: Number(widget.getAttribute("data-br-review-average") || 0),
      count: Number(widget.getAttribute("data-br-review-count") || 0),
    };
  }

  function applyStats(widget, stats) {
    if (!widget || !stats) {
      return;
    }

    var average = Number(stats.average || 0);
    var count = Number(stats.count || 0);
    widget.setAttribute("data-br-review-average", String(average));
    widget.setAttribute("data-br-review-count", String(count));

    setText(widget.querySelector("[data-br-review-average-value]"), average.toFixed(1));
    setText(widget.querySelector("[data-br-review-count-value]"), String(count));
    setText(
      widget.querySelector("[data-br-review-live-summary]"),
      "דירוג ממוצע " + average.toFixed(1) + " מתוך 5, " + count + " חוות דעת"
    );
    updateReadonlyRating(widget.querySelector("[data-br-review-average-stars]"), average);
  }

  function initWidget(widget) {
    if (!widget || widget.getAttribute("data-br-review-bound") === "1") {
      return;
    }
    widget.setAttribute("data-br-review-bound", "1");
    applyStats(widget, readInitialStats(widget));
  }

  function initBusinessReviewWidgets() {
    var widgets = document.querySelectorAll("[data-br-review-widget]");
    for (var i = 0; i < widgets.length; i++) {
      initWidget(widgets[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBusinessReviewWidgets, { once: true });
  } else {
    initBusinessReviewWidgets();
  }
})();
